// Pre-defined ADQL query templates
export interface AdqlTemplate {
  id: string;
  name: string;
  description: string;
  query: string;
  parameters?: {
    name: string;
    label: string;
    type: 'number' | 'text' | 'date';
    default?: string | number;
    min?: number;
    max?: number;
  }[];
}

export const adqlTemplates: AdqlTemplate[] = [
  {
    id: 'basic-limit',
    name: 'Basic query with limit',
    description: 'Simple query that returns a limited number of results',
    query: 'SELECT TOP 10 * FROM ivoa.ObsCore',
    parameters: [],
  },
  {
    id: 'spatial-search',
    name: 'Spatial search around M51',
    description: 'Spatial search around M51',
    query:
      "SELECT obs_publisher_did, target_name, dataproduct_type, dataproduct_subtype, calib_level, obs_collection, access_url, facility_name, instrument_name, obs_id, s_ra, s_dec, DISTANCE(POINT('ICRS', 202.469575, 47.1952583), POINT('ICRS', s_ra, s_dec)) AS angular_separation FROM rucio.obscore WHERE (CONTAINS(POINT('ICRS', s_ra, s_dec), CIRCLE('ICRS', 202.469575, 47.1952583, 1.0)) = 1) ORDER BY angular_separation ASC",
    parameters: [],
  },
  {
    id: 'product-type-facility',
    name: 'Search data-product type by facility',
    description: 'Search data-product type by facility',
    query:
      'SELECT dataproduct_type, facility_name, COUNT(*) AS num_records FROM rucio.obscore GROUP BY dataproduct_type, facility_name ORDER BY dataproduct_type, num_records DESC',
    parameters: [],
  },
  {
    id: 'image-prod-types',
    name: 'All image data products',
    description: 'All image data products',
    query:
      "SELECT obs_publisher_did, target_name, dataproduct_type, facility_name, instrument_name, s_ra, s_dec FROM rucio.obscore WHERE (dataproduct_type = 'image') ORDER BY target_name ASC",
    parameters: [],
  },
];

// Function to apply parameters to a template
export const applyTemplateParameters = (
  template: AdqlTemplate,
  parameters: Record<string, string | number>,
): string => {
  let query = template.query;

  // Replace each parameter in the query
  Object.entries(parameters).forEach(([key, value]) => {
    const regex = new RegExp(`\\{${key}\\}`, 'g');
    query = query.replace(regex, value.toString());
  });

  return query;
};
